


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLogos } from "../Constant/Constant";




const ForgetPassword = () => {
  const logos = getLogos();
  const navigate = useNavigate();

  const handleBackToLogin =()=>{
    navigate("/")
  }
  const [email, setEmail] = useState('');



  return (
    <>
      <div className='flex '>
      <div className="w-6/12 h-screen bg-gradient-to-b from-[rgb(57,156,122)] to-[#14362A] flex justify-center">
          <img className="2xl:w-6/12 3xl:w-5/12  xl:w-5/12 lg:w-6/12" src={logos.glFunnelImage} alt="" />
          <div className="absolute 2xl:inset-x-[130px] 2xl:inset-y-[310px] 3xl:inset-x-[220px] 3xl:inset-y-[360px] xl:inset-y-[240px] xl:inset-x-[125px]  lg:inset-x-[90px] lg:inset-y-[240px] ">
            <p className="text-white 2xl:text-5xl font-bold xl:text-4xl lg:text-3xl w-96">GL Funnel</p>
            <p className="text-white 2xl:text-xl text-xl ml-2 w-64 ">Your hustling partner</p>
          </div>

        </div>
        <div className="w-6/12 flex justify-center">
          <div className='absolute right-4 '>
            <img className="p-5 xl:w-24 lg:w-24" src={logos.clientLogo} alt="" />
          </div>
          <div className='mt-52 mx-56  3xl:mt-64' >
            <form className='flex flex-col gap-5' >
              <h1 className='font-bold 2xl:text-2xl lg:text-xl 3xl:text-3xl '>Forgot Your password?</h1>

              <label className='font-light text-xl lg:text-sm 3xl:text-xl' htmlFor="login">Enter your mail ID  below, we will send you <br /> a password reset link</label>

              <input


                type="text"
                className="shadow appearance-none z-10  focus:outline-none border rounded w-[398px] 3xl:w-[430px] custom-xl:w-[398px] lg:w-72 h-10 px-3 text-gray-700"
                placeholder="Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />


              <button className='bg-customGreen text-center text-xl  text-white w-[398px] 3xl:w-[430px] custom-xl:w-[398px] lg:w-72 lg:text-lg h-10 mt-5  rounded-md shadow-md'>
              Send Reset Link
              </button>
              <p className='text-[#007AFF] 2xl:pl-72 2xl:ml-2 3xl:ml-3 xl:pl-72 xl:ml-2 lg:pl-44 lg:ml-2 w-full cursor-pointer text-sm 3xl:text-lg' onClick={handleBackToLogin}>Return to Login</p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
